import React from 'react';

const DashboardHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Hub Dashboard
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Hub Dashboard provides an overview of your organization's key metrics,
          projects, and support activity. It's your central command center for
          monitoring business operations.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Metrics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          The top section displays important statistics:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Active Projects:</strong> Number of ongoing projects</li>
          <li><strong>Total Revenue:</strong> Financial performance metrics</li>
          <li><strong>Support Tickets:</strong> Open and pending support requests</li>
          <li><strong>Team Members:</strong> Active users in your organization</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Support Requests Section
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Quick access to recent support activity:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>View pending tickets that need attention</li>
          <li>Click "View All" to access the full support management interface</li>
          <li>Create new support requests (clients only)</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Date Range Filter
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Filter dashboard data by time period:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>All time:</strong> View cumulative data</li>
          <li><strong>Last 7/30/90 days:</strong> Recent time windows</li>
          <li><strong>Custom range:</strong> Select specific start and end dates</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Charts & Analytics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Visual representations of your data including cost trends, project status
          distribution, and other key performance indicators. Charts update based on
          your selected date range.
        </p>
      </div>

    </>
  );
};

export default DashboardHelp;
